export const GENERATE_REPORT = (organizationId: string) => {
  return `base/organizations/${organizationId}/reports`;
};

export const FETCH_COMMENTS = (investmentId: string) => {
  return `base/investments/${investmentId}/notes`;
};

export const DOWNLOAD_REPORT = (organizationId: string, jobId: string) => {
  return `base/organizations/${organizationId}/reports/${jobId}/download`;
};

export const FETCH_REPORTS = (organizationId: string) => {
  return `base/organizations/${organizationId}/reports`;
};
